// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WebhookActionResponse

import { BookingEventActionType } from './enums.gen';

export type WebhookActionApiResponse = {
	type: BookingEventActionType.Webhook;
	url: string;
	method: string;
	headers: Record<string, string>;
	payload: string;
};

export type WebhookAction = {
	type: BookingEventActionType.Webhook;
	url: string;
	method: string;
	headers: Record<string, string>;
	payload: string;
};

export function hydrateWebhookAction(data: WebhookActionApiResponse): WebhookAction {
	return {
		...data,
		headers: Array.isArray(data.headers) ? {} : data.headers,
	};
}